declare const angular: ng.IAngularStatic
export var browsProductComponent = {
    template: `
            <div class="card" layout="row" layout-align="space-around center">
                <div flex="30">
                    <md-autocomplete
                            md-selected-item="selectedItem"
                            md-search-text-change="searchTextChange(searchText)"
                            md-search-text="searchText"
                            md-selected-item-change="selectedItemChange(item)"
                            md-items="item in loadProductTypes(searchText)"
                            md-item-text="item.ProductTypeName"
                            md-min-length="0"
                            placeholder="فیلتر گروه کالایی والد">
                        <md-item-template>
                            <span md-highlight-text="searchText" md-highlight-flags="^i">{{item.ProductTypeName}}</span>
                        </md-item-template>
                        <md-not-found>
                            هیچ موردی برای "{{searchText}}" یافت نشد.
                        </md-not-found>
                    </md-autocomplete>
                </div>
                <div flex="30">
                    <md-input-container  class="md-icon-float md-icon-right  md-block">
                        <label>جستجو در نام محصول</label>
                        <input name="name" type="text" ng-model="filters.ProductName" ng-change="changeFilter()" />
                        <md-icon aria-label="label" ><i class="fa fa-search"></i></md-icon>
                    </md-input-container>
                </div>
            </div>
            <div class="card-panel spn-gridList">
                <ul class="header">
                    <li layout="row" layout-align="start center">
                        <span flex="10"><md-checkbox class="md-primary" name="name" ng-model="masterCheckbox" ng-change="checkOrUncheckAll()" ng aria-label="label"></md-checkbox></span>
                        <span flex="95">Name</span>
                    </li>
                </ul>
                <ul class="body">
                    <spn-loading ng-if="productQuery.AjaxLoading || !productQuery"></spn-loading>
                    <li layout="row" layout-align="start center" ng-repeat="product in productQuery.Data">
                        <span flex="10"><md-checkbox class="md-primary" name="name" ng-model="BrowsModel[product.ProductID].isChecked" ng-change="changeCheck(product)" aria-label="label"></md-checkbox></span>
                        <span flex="95">{{product.ProductName}}</span>
                    </li>
                    <li layout="row" layout-align="start center" ng-if="productQuery.TotalCount === 0">
                        <span flex="100" class="text-center">موردی یافت نشد.</span>
                    </li>
                </ul>
                <ul class="footer">
                    <li layout="row" layout-align="start center">
                        <span flex="50" layout="row" layout-align="start center" style="padding-right: 40px">
                           
                            <pagination page-change="change(pageNumber)" self-page-change="true" page-number="productQuery.PageNumber" page-size="productQuery.PageSize"
                            total-items="productQuery.TotalCount"></pagination>
                        </span>
                        <span flex="50" layout="row" layout-align="end center" style="padding-left: 40px">
                            <md-select ng-change="change()" flex="20" ng-model="productQuery.PageSize">
                                <md-option ng-repeat="state in [10,15,20,50,100]" ng-value="state" >
                                    {{state}}
                                </md-option>
                            </md-select>
                            مورد در صفحه
                        </span>
                    </li>
                </ul>
            </div>
            <div class="mt-10" layout="row" layout-align="center center">
                <md-button class="md-raised md-primary" ng-click="save()" aria-label="label">ذخیره</md-button>
            </div>
        `,
    controller: ProductComponentController,
    bindings: {
        onSave: '&',
        ngModel: '@'
    }
}
function ProductComponentController($scope, $Product, $ProductType, $Category, $timeout, $http, MyConstant) {
    "ngInject"

    var ctrl = this;
    $scope.BrowsModel = {};

    $scope.productQuery = $Product.query()

    $scope.checkOrUncheckAll = () => {
        $scope.productQuery.Data.map((item) => {
            if ($scope.masterCheckbox) {
                item.isChecked = true;
                $scope.BrowsModel[item.ProductID] = item;
            }
            else {
                delete $scope.BrowsModel[item.ProductID];
            }
        })

    }

    $scope.changeCheck = (item) => {
        if ($scope.BrowsModel[item.ProductID].isChecked) {
            item.isChecked = true;
            $scope.BrowsModel[item.ProductID] = item;
        }
        else {
            delete $scope.BrowsModel[item.ProductID];
        }
    }

    var changeFilterTimeout;
    $scope.changeFilter = () => {
        $scope.masterCheckbox = null;
        $timeout.cancel(changeFilterTimeout);
        $scope.productQuery.AjaxLoading = true;
        changeFilterTimeout = $timeout(() => {

            var filters = []
            angular.forEach($scope.filters, (val, key) => {
                var item = { Property: key, Value: val }
                filters.push(item)
            })
            $scope.productQuery.Filters = JSON.stringify(filters)
            $scope.productQuery.$query()
        }, 300)
    }
    $scope.change = (pageNumber) => {
        $scope.productQuery.PageNumber = pageNumber
        $scope.masterCheckbox = null;
        var filters = []
        angular.forEach($scope.filters, (val, key) => {
            var item = { Property: key, Value: val }
            filters.push(item)
        })
        $scope.productQuery.Filters = JSON.stringify(filters)
        $scope.productQuery.AjaxLoading = true;
        $scope.productQuery.$query()
    }
    $scope.selectedItemChange = (item) => {
        $scope.filters = $scope.filters || {}
        if (item) {
            $scope.filters.ProductTypeID = item.ProductTypeID
        }
        else {
            delete $scope.filters.ProductTypeID;
        }
        $scope.changeFilter()
    }
    $scope.loadProductTypes = (searchText) => {
        if (searchText) {
            return $http.get(`${MyConstant.ApiUrl}product/productTypes?Filters=[{Property:"ProductTypeName",Value:"${searchText}"}]`).then((res) => {
                return res.data.Data
            })
        }
        else {
            return $http.get(`${MyConstant.ApiUrl}product/productTypes`).then((res) => {
                return res.data.Data
            })
        }
    }
    $scope.loadCategories = () => {
        $scope.productQuery = $Category.query({ PageSize: 1000 })
    }

    $scope.save = () => {
        ctrl.onSave({ data: $scope.BrowsModel })
    }
}


// WEBPACK FOOTER //
// ./src/components/browsProduct/browsProduct.component.ts